import type { ReactNode } from "react";

export function Badge({ tone, children }: { tone: "on" | "off" | "kind"; children: ReactNode }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function PublishedBadge({ published }: { published: boolean }) {
  return <Badge tone={published ? "on" : "off"}>{published ? "Published" : "Draft"}</Badge>;
}
